export default [
  {
    "元号": "令和",
    "改元日": "2019/05/01"
  },
  {
    "元号": "平成",
    "改元日": "1989/01/08"
  },
  {
    "元号": "昭和",
    "改元日": "1926/12/25"
  },
  {
    "元号": "大正",
    "改元日": "1912/07/30"
  },
  {
    "元号": "明治",
    "改元日": "1868/10/23"
  }
]
